import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Descriptions, Button, Icon, Col, Spin, Modal, Result,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
import Row from '../../components/Row';
import DispatchView from '../../components/DispatchView';
import Select from '../../components/Select';

import {
  fetchDispatchDetails,
  printDispatchDriver,
  fetchDispatchList,
  fetchOptions,
  fetchOptionsLike,
} from '../ducks';

const styleTable = width => ({
  border: '0.5px solid black',
  fontSize: '12px',
  padding: '5px',
  width,
  borderCollapse: 'collapse',
});

export class TransferView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        courier: [],
        helper: [],
        vehicle:[],
      },
      isFetching: false,
      dispatchDetails: [],
      isMountingModule: true,
      accountStatus: null,
      selectedDriver: null,
      selectedHelper: null,
      selectedVehicle: null,
      hasVisible: false,
      updateStatusLoading: false,
      loadingText: 'Fetching transfer details. . .',
    };

    this.dateAddPrint = this.dateAddPrint.bind(this);
    this.fetchDispatch = this.fetchDispatch.bind(this);
    this.searchOption = this.searchOption.bind(this);

  }

   componentDidMount() {
    this.fetchDispatch();
    
  }
driverSelectHandler(value){
  let state = this;
  this.setState({selectedDriver: value});
  this.state.options.courier.forEach(function(v,i){
    let driverName = '';
    if(value === v.value){
      for(let i = 0; i < v.label.length; i++){
        let c = v.label.charAt(i);
        if(c === '('){
          break;
        }
        driverName = driverName + c;
      }
      state.setState(prevState=>({dispatchDetails:{dispatch:{...prevState.dispatchDetails.dispatch,driver:driverName}}}));
    }
  });
}
helperSelectHandler(value){
  let state = this;
  this.setState({selectedHelper: value});
  this.state.options.courier.forEach(function(v,i){
    let driverName = '';
    if(value === v.value){
      for(let i = 0; i < v.label.length; i++){
        let c = v.label.charAt(i);
        if(c === '('){
          break;
        }
        driverName = driverName + c;
      }
      state.setState(prevState=>({dispatchDetails:{dispatch:{...prevState.dispatchDetails.dispatch,helper:driverName}}}));
    }
  });
}
vehicleSelectHandler(value){
  let state = this;
  this.setState({selectedVehicle: value});
  this.state.options.vehicle.forEach(function(v,i){
    
    if(value === v.value){
      let vehicleName = v.label;
      state.setState(prevState=>({dispatchDetails:{dispatch:{...prevState.dispatchDetails.dispatch,vehicle_name:vehicleName}}}));
    }
  });
}
searchOption(type, e) {
    const { doFetchOptionsLike } = this.props;

    this.setState({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          [type]: action.payload.data.slice(0, 50),
        },
        isFetching: false,
      }));
    });
  }
  fetchDispatch() {
    const { doFetchDispatchDetails, match, doFetchDispatchList,doFetchOptionsLike } = this.props;

    doFetchDispatchDetails(match.params.id).then((action) => {
      let self = this;
      this.setState({
        dispatchDetails: action.payload.data,
        isMountingModule: false,
      });
      this.setState({selectedDriver: action.payload.data.dispatch.driver_id,selectedHelper:action.payload.data.dispatch.helper_id,selectedVehicle:action.payload.data.dispatch.vehicle_id});
const {doFetchOptions,selectOptions} = this.props;
    doFetchOptions('courier').then((action) => {
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            courier: action.payload.data.slice(0,50)
          },
        }));
        let allCouriers = action.payload.data;
        let isDriverExist = false;
        self.state.options.courier.forEach(function(v,i){
          if(v.value === self.state.selectedDriver){
            isDriverExist = true;
          }
        });
        if(!isDriverExist){
          allCouriers.forEach(function(v,i){
            if(v.value === self.state.selectedDriver){
              self.setState(prevState=>({options:{courier:[...prevState.options.courier,v]}}));
            }
          });
        }
        let isHelperExist = false;
        self.state.options.courier.forEach(function(v,i){
          if(v.value === self.state.selectedHelper){
            isHelperExist = true;
          }
        });
        if(!isHelperExist && self.state.selectedDriver !== self.state.selectedHelper){
          allCouriers.forEach(function(v,i){
            if(v.value === self.state.selectedHelper){
              self.setState(prevState=>({options:{courier:[...prevState.options.courier,v]}}));
            }
          });
        }
      });
      doFetchOptions('vehicle').then((action) => {
        self.setState(prevState => ({
          options: {
            ...prevState.options,
            vehicle: action.payload.data
          },
        }));
      });
    
    });

    const params = {
      export: false,
      filter: [
        { id: 'type', value: 'transfer' },
        { id: 'dh_id', value: match.params.id },
      ],
      page: 0,
      pageSize: 10,
      sorted: [],
    };
    doFetchDispatchList(params).then((res) => {
      this.setState({ accountStatus: res.payload.data.rows[0].status });
    });
  }

  confimationPrint() {
    this.setState({
      hasVisible: true,
    });
  }

  handleCancel() {
    this.setState({
      hasVisible: false,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  printOnlyManifest() {
    const content = document.getElementById('divcontents');
    const pri = document.getElementById('ifmcontentstoprint').contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  printDispatch() {
    this.setState({
      updateStatusLoading: true,
      isMountingModule: true,
      loadingText: 'Updating dispatch . . .',
    });
    const { doPrintDispatch, match } = this.props;
    doPrintDispatch(match.params.id,this.state.selectedDriver,this.state.selectedHelper,this.state.selectedVehicle).then(() => {
      this.setState({
        hasVisible: false,
        updateStatusLoading: false,
      });
      const content = document.getElementById('divcontents');
      const pri = document.getElementById('ifmcontentstoprint').contentWindow;
      pri.document.open();
      pri.document.write(content.innerHTML);
      pri.document.close();
      pri.focus();
      pri.print();
      this.fetchDispatch();
    });
    // const { tableDataBody } = this.state;
    // console.log(tableDataBody.map(res => (res))[0]);
  }

  // eslint-disable-next-line class-methods-use-this
  dateAddPrint(date) {
    const dateAdd = new Date(date);
    dateAdd.setDate(dateAdd.getDate() + 6);
    const formatDate = format(dateAdd, 'YYYY-MM-DD');

    return formatDate;
  }

  render() {
    const {
      dispatchDetails,
      isMountingModule,
      accountStatus,
      hasVisible,
      updateStatusLoading,
      loadingText,
      options,
      selectedDriver,
      selectedHelper,
      selectedVehicle,
      isFetching,
    } = this.state;
    const { match } = this.props;
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Transfer',
      },
      {
        breadcrumbName: 'List',
      },
      {
        breadcrumbName: `View #${match.params.id}`,
      },
    ];

    const dispatchPackageListColumns = [
      {
        id: 'tracking_number',
        Header: 'Tracking Number',
        filterable: false,
        // sortable: false,
        accessor: data => data.tracking_number,
      },
      {
        id: 'consignee_name',
        Header: 'Consignee Name',
        filterable: false,
        // sortable: false,
        accessor: data => data.consignee_name,
      },
      {
        id: 'consignee_address',
        Header: 'Consignee Address',
        filterable: false,
        // sortable: false,
        accessor: data => data.consignee_address,
      },
      {
        id: 'payment_type',
        Header: 'Payment Type',
        filterable: false,
        // sortable: false,
        accessor: data => data.payment_type,
      },
      {
        id: 'handover_date',
        Header: 'Handover Date',
        filterable: false,
        // sortable: false,
        accessor: data => data.handover_date,
      },
      {
        id: 'status',
        Header: 'Status',
        filterable: false,
        // sortable: false,
        accessor: data => data.status,
      },
    ];

    return (
      <div className="TransferView">
        <Modal
          title="New status confirmation"
          visible={hasVisible}
          // onOk={() => this.printDispatch()}
          // onCancel={() => this.handleCancel()}
          footer={(
            <React.Fragment>
              <Button
                disabled={updateStatusLoading}
                onClick={() => this.handleCancel()}
              >
                Cancel
              </Button>
              {updateStatusLoading ? (
                <Button
                  disabled={updateStatusLoading}
                  style={{ backgroundColor: '#e8641a' }}
                  onClick={() => this.printDispatch()}
                >
                  <Icon
                    type="loading"
                    style={{ fontSize: 16, color: 'white' }}
                    spin
                  />
                  Confirm
                </Button>
              ) : (
                <Button type="primary" onClick={() => this.printDispatch()}>
                  Confirm
                </Button>
              )}
            </React.Fragment>
)}
        >
                        <label>Select Driver: &nbsp;&nbsp;</label>
                            <Select
                                allowClear
                                loading={isFetching}
                                options={options.courier}
                                onSearch={e => this.searchOption('courier', e)}
                                onChange={(event) => this.driverSelectHandler(event)}
                                filterOption={false}
                                value={selectedDriver}
                                placeholder="Type to search for desired driver"
                                showSearch
                                 style={{ width: 300 }}
                              /><br></br><br></br>
                              <label>Select Helper:&nbsp;&nbsp;</label>
                            <Select
                                allowClear
                                loading={isFetching}
                                options={options.courier}
                                onSearch={e => this.searchOption('courier', e)}
                                onChange={(event) => this.helperSelectHandler(event)}
                                filterOption={false}
                                value={selectedHelper}
                                placeholder="Type to search for desired helper"
                                showSearch
                                 style={{ width: 300 }}
                              /><br></br><br></br>
                              <label>Select Vehicle: </label>
                            <Select
                                allowClear
                                loading={isFetching}
                                options={options.vehicle}
                                onSearch={e => this.searchOption('vehicle', e)}
                                onChange={(event) => this.vehicleSelectHandler(event)}
                                filterOption={false}
                                value={selectedVehicle}
                                placeholder="Type to search for desired vehicle"
                                showSearch
                                 style={{ width: 300 }}
                              />
          <Result
            status="warning"
            title="Are you sure you want to print this manifest?"
          />
        </Modal>
        <div style={{ display: 'none' }} id="divcontents">
          <center>
            <strong style={{ fontSize: '14px' }}>
              ORIGINATING WAREHOUSE MANIFEST
            </strong>
          </center>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '100%',
              marginTop: '20px',
              marginBottom: '20px',
            }}
          >
            <div
              style={{
                width: '25%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
                float: 'left',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Dispatch Number: </strong>
                {dispatchDetails.dispatch ? dispatchDetails.dispatch.dh_id : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Operator: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.driver
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Outsource: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.outsource
                  : ''}
              </p>
            </div>
            <div
              style={{
                width: '25%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Vehicle: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.vehicle_name
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Mobile Number: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.driver_mobile
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Dispatch Date: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.dispatch_date
                  : ''}
              </p>
            </div>
            <div
              style={{
                width: '25%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Destination: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.destination
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Helper: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.helper
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Remarks: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.remarks
                  : ''}
              </p>
            </div>
            <div
              style={{
                width: '23%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
                float: 'right',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Origin: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.port_code
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Mobile Number: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.helper_mobile
                  : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Dispatch By: </strong>
                {dispatchDetails.dispatch
                  ? dispatchDetails.dispatch.added_by
                  : ''}
              </p>
            </div>
          </div>
          <div style={{ marginBottom: '30px' }}>
            <strong style={{ fontSize: '12px' }}>Customer Waybill</strong>
            <table style={styleTable()}>
              <thead>
                <tr>
                  <th style={styleTable('5%')} />
                  <th style={styleTable('12%')}>Cargo #</th>
                  <th style={styleTable('12%')}>Total Qty.</th>
                  <th style={styleTable('12%')}>Waybill Date</th>
                  <th style={styleTable('12%')}>Expected Return Date</th>
                  <th style={styleTable('12%')}>Province</th>
                  <th style={styleTable('12%')}>LM Crew</th>
                  <th style={styleTable('12%')}>Receiver</th>
                  <th style={styleTable('12%')}>OIC</th>
                </tr>
              </thead>

              <tbody>
                {dispatchDetails.packages
                  ? dispatchDetails.packages.map((val, key) => (
                    <React.Fragment key={key}>
                      <tr key={`${key}a`}>
                        <td style={styleTable('5%')}>{key + 1}</td>
                        <td style={styleTable('12%')}>
                          {val.tracking_number ? val.tracking_number : ' '}
                        </td>
                        <td style={styleTable('12%')}>
                          {val.total_price ? val.total_qty : ' '}
                        </td>
                        <td style={styleTable('12%')}>{val.handover_date ? val.handover_date.split(' ')[0] : ' '}</td>
                        <td style={styleTable('12%')}>
                          {this.dateAddPrint(val.handover_date)}
                        </td>
                        <td style={styleTable('12%')}>
                          {val.address_province ? val.address_province : ' '}
                        </td>
                        <td style={styleTable('12%')} />
                        <td style={styleTable('12%')} />
                        <td style={styleTable('12%')} />
                      </tr>
                    </React.Fragment>
                  ))
                  : null}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '12px', margin: '5px' }}>
            {'Total Transaction:'}
            {' '}
            <span style={{ color: 'red' }}>
              {dispatchDetails.packages ? dispatchDetails.packages.length : 0}
            </span>
          </p>
          <p style={{ fontSize: '12px', margin: '5px' }}>
            {'Total Weight:'}
            {' '}
            {dispatchDetails.packages
              ? dispatchDetails.packages.length !== 0
                ? dispatchDetails.packages
                  .map(res => parseFloat(res.weight))
                  .filter(resFilter => resFilter).length === 0
                  ? 0
                  : dispatchDetails.packages
                    .map(res => parseFloat(res.weight))
                    .filter(resFilter => resFilter)
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                : 0
              : 0}
          </p>
          <div style={{ marginTop: '50px' }}>
            <i style={{ fontSize: '12px', float: 'left' }}>
              This document is an accountable form. Please print your name and
              signature upon receipt. This signed document must be returned to
              our main office on or before 9 working days.
            </i>
          </div>
          <div style={{ marginTop: '150px' }}>
            <table style={{ width: '95%' }}>
              <tbody>
                <tr>
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Origin Copy
                  </td>
                  <td style={{ width: '33.33%' }} />
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Driver Copy 1
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '15px' }} />
                  <td style={{ padding: '15px' }} />
                </tr>
                <tr>
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Crossdock Copy
                  </td>
                  <td style={{ width: '33.33%' }} />
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Driver Copy 2
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '15px' }} />
                  <td style={{ padding: '15px' }} />
                </tr>
                <tr>
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Destination Copy
                  </td>
                  <td style={{ width: '33.33%' }} />
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Driver Copy 3
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '15px' }} />
                  <td style={{ padding: '15px' }} />
                </tr>
                <tr>
                  <td style={{ width: '33.33%', textAlign: 'center', borderTop: '1px solid black' }}>
                Return Copy
                  </td>
                  <td style={{ width: '33.33%' }} />
                  <td style={{ width: '33.33%' }}>
                Notes:
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <strong style={{ fontSize: '12px', float: 'left' }}>
              Signature of Warehouse Representative
            </strong>
            <strong
              style={{ fontSize: '12px', float: 'left', marginLeft: '250px' }}
            >
              Signature of Operator
            </strong> */}
          </div>
        </div>
        <iframe
          title="myFrame"
          id="ifmcontentstoprint"
          style={{ height: '0px', width: '0px', position: 'absolute' }}
        />
        <Spin
          spinning={isMountingModule}
          size="small"
          tip={loadingText}
        >
          <PageHeader
            title={`Transfer #${match.params.id}`}
            routes={breadCrumbs}
          />
          <Spacer />
          <Container>
            <DispatchView
              dispatchTitle="Transfer Information"
              dispatchExportName="Transfer"
              loadingUpdate={updateStatusLoading}
              dispatchPackageListColumns={dispatchPackageListColumns}
              dispatchItems={dispatchDetails.packages}
              hasExport
              exportType="dispatch"
              exportId={match.params.id}
              dispatchDetails={(
                <React.Fragment>
                  <Descriptions bordered size="small">
                    <Descriptions.Item label="Driver: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.driver
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Type: " span={2}>
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.type
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Origin: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.port_code
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Vehicle: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.vehicle_name
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Destination: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.destination
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Dispatch Date: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.dispatch_date
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Outsource: ">
                      {dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.outsource
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Processed By: ">
                      {dispatchDetails.dispatch
                        ? `${dispatchDetails.dispatch.added_by}`
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Mode Of Shipment: ">
                      {dispatchDetails.dispatch
                        ? `${dispatchDetails.dispatch.mode_of_shipment}`
                        : ''}
                    </Descriptions.Item>
                    <Descriptions.Item label="Shipment Provider: ">
                      {// eslint-disable-next-line no-nested-ternary
                      dispatchDetails.dispatch
                        ? dispatchDetails.dispatch.carrier !== null
                          ? dispatchDetails.dispatch.carrier
                          : 'N/A'
                        : ''}
                    </Descriptions.Item>
                  </Descriptions>
                </React.Fragment>
)}
              printTypes={(
                <React.Fragment>
                  <Row>
                    { accountStatus !== 'new' ? (
                      <Col xs={24} sm={24} lg={8} style={{ marginBottom: 5 }}>
                        <Button
                          onClick={() => this.printOnlyManifest()}
                          type="primary"
                          block
                        >
                          <Icon viewBox="0 0 1024 1024">
                            <FontAwesomeIcon icon={faPrint} fixedWidth />
                          </Icon>
                          Print Manifest Only
                        </Button>
                      </Col>
                    ) : null }
                    <Col xs={24} sm={24} lg={accountStatus !== 'new' ? 8 : 12} style={{ marginBottom: 5 }}>
                      <Button
                        onClick={
                          accountStatus === 'new'
                            ? () => this.confimationPrint()
                            : () => this.printDispatch()
                        }
                        type="primary"
                        block
                      >
                        <Icon viewBox="0 0 1024 1024">
                          <FontAwesomeIcon icon={faPrint} fixedWidth />
                        </Icon>
                        Print and Update
                      </Button>
                    </Col>
                    <Col xs={24} sm={24} lg={accountStatus !== 'new' ? 8 : 12}>
                      <Button
                        onClick={() => window.open(
                          `${process.env.REACT_APP_API_URL}/web/dispatch/tripmonitoring/${match.params.id}`,
                        )
                        }
                        type="primary"
                        block
                      >
                        <Icon viewBox="0 0 1024 1024">
                          <FontAwesomeIcon icon={faPrint} fixedWidth />
                        </Icon>
                        Print Trip Monitoring
                      </Button>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            />
          </Container>
        </Spin>
      </div>
    );
  }
}

TransferView.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchDispatchDetails: PropTypes.func.isRequired,
  doPrintDispatch: PropTypes.func.isRequired,
  doFetchDispatchList: PropTypes.func.isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchDispatchDetails: fetchDispatchDetails,
  doPrintDispatch: printDispatchDriver,
  doFetchDispatchList: fetchDispatchList,
  doFetchOptions: fetchOptions,
  doFetchOptionsLike: fetchOptionsLike,
};

export default connect(null, mapDispatchToProps)(TransferView);
